import { render, staticRenderFns } from "./ThirdStepContainer.vue?vue&type=template&id=708cc5ec&scoped=true&lang=html&"
import script from "./ThirdStepContainer.vue?vue&type=script&lang=ts&"
export * from "./ThirdStepContainer.vue?vue&type=script&lang=ts&"
import style0 from "./ThirdStepContainer.vue?vue&type=style&index=0&id=708cc5ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708cc5ec",
  null
  
)

export default component.exports